import { FC, useMemo, useState } from 'external/react';
import { useNavigate } from 'external/react';
import ClientsTablePurchaseInfoRow from './PurchaseInfoRow';
import useAdmin from 'context/admin-context/hook';

type ClientsTableExpandableRowProps = {
  clientData: any;
};

const ClientsTableExpandableRow: FC<ClientsTableExpandableRowProps> = ({ clientData: item }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const { roleName } = useAdmin();
  const link = useMemo(() => `/${roleName?.substring(0, roleName.indexOf('_') >= 0 ? roleName.indexOf('_') : roleName.length) || 'admin'}/clients/${item.id}`, [roleName])

  return (
    <>
      <tr>
        <td
          className="text-capitalize"
          style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            {item.purchaseData?.length > 0 && (
              <button
                onClick={() => setIsExpanded(prev => !prev)}
                style={{
                  background: 'none',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  padding: '0 5px',
                  fontWeight: 'bold',
                  lineHeight: '1.4',
                  fontSize: '0.85em',
                  flexShrink: 0,
                }}
                aria-label={isExpanded ? 'Collapse' : 'Expand'}
              >
                {isExpanded ? '−' : '+'}
              </button>
            )}
            <a
            
              href={link}
              onClick={e => { e.preventDefault(); navigate(link); }}
              style={{ textDecoration: 'none' }}
            >
              {item.name}
            </a>
          </span>
        </td>
        <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.email}</td>
        <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.domain}</td>
        <td className="text-center">{item.purchases}</td>
        </tr>
      {isExpanded && <ClientsTablePurchaseInfoRow clientData={item} />}

    </>
  );
};

export default ClientsTableExpandableRow;